import { render, staticRenderFns } from "./GameProgressbar.vue?vue&type=template&id=33a72535&scoped=true&"
import script from "./GameProgressbar.vue?vue&type=script&lang=js&"
export * from "./GameProgressbar.vue?vue&type=script&lang=js&"
import style0 from "./GameProgressbar.vue?vue&type=style&index=0&id=33a72535&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33a72535",
  null
  
)

export default component.exports